import { render, staticRenderFns } from "./wages.vue?vue&type=template&id=58616172"
import script from "./wages.vue?vue&type=script&lang=js"
export * from "./wages.vue?vue&type=script&lang=js"
import style0 from "./wages.vue?vue&type=style&index=0&id=58616172&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports